import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/Home.vue'
import Agreement from '../views/Agreement.vue'
import TelecomFraud from '../views/xieyi/telecomFraud.vue'
import AccountService from '../views/xieyi/accountService.vue'
import CampusDiscount from '../views/xieyi/campusDiscount.vue'
import FiveMinistries from '../views/xieyi/fiveMinistries.vue'
import ProductSales from '../views/xieyi/productSales.vue'
import CustomerNetwork from '../views/xieyi/customerNetwork.vue'
import PrivacyPolicy from '../views/xieyi/privacyPolicy.vue'
import AntiFraud from '../views/xieyi/antiFraud.vue'
import Termination from '../views/xieyi/termination.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/sdlg' // 重定向到home页面
  },
  {
    path: '/sdlg',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/telecomFraud',
    name: 'TelecomFraud',
    component: TelecomFraud
  },  
  {  
    path: '/accountService',
    name: 'AccountService',
    component: AccountService
  },  
  {
    path: '/agreement',
    name: 'Agreement',
    component: Agreement
  },
  {
    path: '/campusDiscount',
    name: 'CampusDiscount',
    component: CampusDiscount
  },
  {
    path: '/fiveMinistries',
    name: 'FiveMinistries',
    component: FiveMinistries
  },
  {
    path: '/productSales',
    name: 'ProductSales',
    component: ProductSales
  },
  {
    path: '/customerNetwork',
    name: 'CustomerNetwork',
    component: CustomerNetwork
  },
  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/termination',
    name: 'Termination',
    component: Termination
  },
  {
    path: '/antiFraud',
    name: 'AntiFraud',  
    component: AntiFraud
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

